import { Locale as DateFnsLocale, enUS, es, it, ptBR } from 'date-fns/locale';

import { Locale } from '@mfe/shared/schema-types';

export enum DisplayLanguage {
  Portuguese = 'pt-BR',
  MexicanSpanish = 'es-MX',
  English = 'en-US',
  Italian = 'it-IT',
}

type AvailableLanguage = {
  displayLanguage: DisplayLanguage;
  short: string;
  localized: string;
};

type SupportedLocale = {
  locale: Locale;
  dateFnsLocale: DateFnsLocale;
  displayLanguage: DisplayLanguage;
  numeralLocale: string;
  availableLanguages: AvailableLanguage[];
};

export const supportedLocales: Record<Locale, SupportedLocale> = {
  [Locale.EnUs]: {
    locale: Locale.EnUs,
    dateFnsLocale: enUS,
    displayLanguage: DisplayLanguage.English,
    numeralLocale: 'en',
    availableLanguages: [
      {
        displayLanguage: DisplayLanguage.English,
        short: 'EN',
        localized: 'English',
      },
    ],
  },
  [Locale.PtBr]: {
    locale: Locale.PtBr,
    dateFnsLocale: ptBR,
    displayLanguage: DisplayLanguage.Portuguese,
    numeralLocale: 'pt-br',
    availableLanguages: [
      {
        displayLanguage: DisplayLanguage.English,
        short: 'EN',
        localized: 'English',
      },
      {
        displayLanguage: DisplayLanguage.Portuguese,
        short: 'PT',
        localized: 'Português',
      },
    ],
  },
  [Locale.ItIt]: {
    locale: Locale.ItIt,
    dateFnsLocale: it,
    displayLanguage: DisplayLanguage.Italian,
    numeralLocale: 'it',
    availableLanguages: [
      {
        displayLanguage: DisplayLanguage.English,
        short: 'EN',
        localized: 'English',
      },
      {
        displayLanguage: DisplayLanguage.Italian,
        short: 'IT',
        localized: 'Italiano',
      },
    ],
  },
  [Locale.EsMx]: {
    locale: Locale.EsMx,
    dateFnsLocale: es,
    displayLanguage: DisplayLanguage.MexicanSpanish,
    numeralLocale: 'es',
    availableLanguages: [
      {
        displayLanguage: DisplayLanguage.English,
        short: 'EN',
        localized: 'English',
      },
      {
        displayLanguage: DisplayLanguage.MexicanSpanish,
        short: 'ES',
        localized: 'Español',
      },
    ],
  },
};

export const defaultLocale = supportedLocales[Locale.EnUs];
